import { createI18n } from 'vue-i18n'

export const i18n = createI18n({
  legacy: false,
  locale: 'sk',
  globalInjection: true,
  messages: {
    en: {
      message: {
        language: 'Language',
        hello: 'hello world!'
      }
    },
    sk: {
      address: {
        cancelLocation: 'Zrušiť označenie lokality',
        city: 'Obec',
        country: 'Štát',
        countrySelect: 'Vyberte štát',
        getLocationFromMap: 'Načítaj lokalitu z mapy',
        getFromMap: 'Načítaj z mapy',
        label: 'Adresa',
        latitude: 'Zemepisná šírka',
        loadAddress: 'Načítaj adresu',
        longitude: 'Zemepisná dĺžka',
        street: 'Ulica',
        streetNumber: 'Popisné číslo',
        zip: 'PSČ',
        loadingSuggestions: 'Vyhľadávam...',
        fullAddressPlaceholder: 'Začnite písať adresu',
        fullAddressAutocomplete: 'Načítanie adresy',
        noResultsFound: 'Adresa nenájdená, skúste ďalej písať, alebo načítať z mapy',
        clickToSetPosition: 'Kliknite na mapu pre zadanie GPS pozície',
      },
      admin: {
        accessDeleteConfirm: 'Naozaj chcete zrušiť prístup správcu firmy?',
        accessModified: 'Prístupové práva správcu firmy boli zmenené',
        accessNotModified: 'Prístupové práva správcu firmy sa nepodarilo zmeniť',
        add: 'Pridať správcu firmy',
        addEmployee: 'Pridať zamestnanecký prístup',
        created: 'Správca firmy bol vytvorený',
        detail: 'Detail správcu firmy',
        edit: 'Upraviť správcu firmy',
        edited: 'Správca firmy bol upravený',
        list: 'Správcovia firmy',
        name: 'Správca firmy',
        notCreated: 'Nepodarilo sa vytvoriť správcu firmy',
        notEdited: 'Nepodarilo sa upraviť správcu firmy',
        notLoaded: 'Nepodarilo sa načítať správcu firmy',
        select: 'Vyberte správcu firmy',
        selectMore: 'Vyberte správcov firmy',
        role: {
          list: 'Zoznam rolí',
          item: 'Rola',
          type: {
            branchManagers: 'Manažéri pobočiek',
            BRANCH_MANAGER: 'Manažér pobočky',
            providerManagers: 'Manažéri firmy',
            PROVIDER_MANAGER: 'Manažér firmy',
            providerEmployees: 'Zamestnanecké prístupy',
            PROVIDER_EMPLOYEE: 'Zamestnanec'
          }
        }
      },
      advertisement: {
        add: 'Pridať reklamu',
        convert: 'Vytvoriť firmu s pobočkou',
        created: 'Reklama bola vytvorená',
        detail: 'Detail reklamy',
        edit: 'Upraviť reklamu',
        edited: 'Reklama bola upravená',
        list: 'Reklamy',
        name: 'Reklama',
        notCreated: 'Nepodarilo sa vytvoriť reklamu',
        notEdited: 'Nepodarilo sa upraviť reklamu',
        notLoaded: 'Nepodarilo sa načítať reklamu'
      },
      branch: {
        add: 'Pridať pobočku',
        category: {
          title: 'Kategórie',
          select: 'Vyberte kategórie'
        },
        created: 'Pobočka bola vytvorená',
        detail: 'Detail pobočky',
        edit: 'Upraviť pobočku',
        edited: 'Pobočka bola upravená',
        list: 'Pobočky',
        name: 'Pobočka',
        notCreated: 'Nepodarilo sa vytvoriť pobočku',
        notEdited: 'Nepodarilo sa upraviť pobočku',
        notLoaded: 'Nepodarilo sa načítať pobočku',
        place: {
          list: 'Miesta',
          name: 'Miesto',
          nullSelect: 'Bez miesta',
          select: 'Vyberte miesto',
          selectMore: 'Vyberte miesta'
        },
        select: 'Vyberte pobočku',
        selectMore: 'Vyberte pobočky'
      },
      branchPlace: {
        add: 'Pridať miesto',
        cloned: 'Miesto bolo naklonované',
        created: 'Miesto bolo vytvorené',
        detail: 'Detail miesta',
        edit: 'Upraviť miesto',
        edited: 'Miesto bolo upravené',
        list: 'Miesta',
        name: 'Miesto',
        notCreated: 'Nepodarilo sa vytvoriť miesto',
        notEdited: 'Nepodarilo sa upraviť miesto',
        notLoaded: 'Nepodarilo sa načítať miesto',
        notCloned: 'Nepodarilo sa naklonovať miesto',
      },
      category: {
        list: 'Kategórie',
        edit: 'Upraviť kategóriu',
        edited: 'Kategória bola upravená',
        notEdited: 'Nepodarilo sa upraviť kategóriu',
        notLoaded: 'Nepodarilo sa načítať kategóriu',
        customTitle: 'Nadpis pre WEB',
        customContent: 'Doplnkový obsah',
        customFooter: 'Doplnková pätička',
        metaDescription: 'Meta popis',
      },
      common: {
        active: 'Aktívne',
        activeShe: 'Aktívna',
        add: 'Pridať',
        added: 'Pridané',
        addConfirmPoints: 'Pridať body',
        address: 'Adresa',
        adminData: 'Údaje o správcovi',
        agreeTo: 'Súhlasím so',
        approve: 'Schváliť',
        approved: 'Schválená',
        back: 'Späť',
        bindings: 'Väzby',
        blockByProvider: 'Blokovať poskytovateľom',
        blockedByProvider: 'Blokované poskytovateľom',
        blockByProviderDescription: 'Blokácia zdroja, zamestnanca, alebo miesta bude pre všetky služby!',
        branchImg: 'Obrázok do zoznamu pobočiek',
        branchImgWide: 'Obrázok do detailu pobočky',
        cancel: 'Zrušiť',
        capacity: 'Kapacita',
        clone: 'Klonovať',
        close: 'Zavrieť',
        closeDetail: 'Zavrieť detail',
        companyData: 'Firemné údaje',
        contactData: 'Kontaktné údaje',
        created: 'Vytvorené',
        customer: 'Zákazník',
        customerTime: 'Zákaznícky čas',
        dashboard: 'Nástenka',
        days: {
          selectMore: 'Vyberte pracovné dni',
          list: 'Pracovné dni',
          monday: 'Pondelok',
          tuesday: 'Utorok',
          wednesday: 'Streda',
          thursday: 'Štvrtok',
          friday: 'Piatok',
          saturday: 'Sobota',
          sunday: 'Nedeľa'
        },
        date: 'Dátum',
        dateFrom: 'Dátum od',
        dateTo: 'Dátum do',
        deleteReservation: 'Zrušiť rezerváciu',
        deleteConfirmReservation: 'Potvrdiť zrušenie rezervácie',
        description: 'Popis',
        detail: 'Detail',
        displayName: 'Zobrazené meno',
        duration: 'Trvanie',
        edit: 'Upraviť',
        eventColor: 'Farba udalosti v kalendári',
        gdpr: 'spracovaním osobných údajov',
        gpsManualEntry: 'Manuálne zadanie súradníc',
        changePassword: 'Zmeniť heslo',
        changeRole: 'Zmeniť rolu',
        imageUpload: {
          drop: 'Presuňte obrázok',
          upload: 'Nahrajte obrázok',
          unsuported: 'Nepodporovaný obrázok'
        },
        internalName: 'Interný názov',
        language: {
          sk_SK: 'Slovensky',
          en_UK: 'Anglicky',
          cs_CZ: 'Česky',
          de_DE: 'Nemecky',
          pl_PL: 'Poľsky'
        },
        locale: 'Jazyk',
        logout: 'Odhlásiť',
        name: 'Názov',
        manual: 'Manuál pre poskytovateľa',
        no: 'Nie',
        notActiveShe: 'Neaktívna',
        notVisibleShe: 'Neviditeľná',
        notActive: 'Neaktívny',
        notVisible: 'Neviditeľný',
        note: 'Poznámka',
        password: 'Heslo',
        paymentTypes: {
          title: 'Spôsoby platby',
          titleOne: 'Spôsob platby',
          select: 'Vyberte spôsoby platby',
          selectOne: 'Vyberte spôsob platby',
          cash: 'Hotovosť',
          card: 'Platobnou kartou',
          loyalty_points: 'Vernostnými bodmi',
          gastro_voucher: 'Stravnými lístkami',
          gastro_card: 'Stravnou kartou'
        },
        personName: 'Meno',
        personLastname: 'Priezvisko',
        personLastnameNotShowingOnWeb: 'priezvisko sa nezobrazuje na webe',
        phoneNumber: 'Telefónne číslo',
        pointStatus: 'Bodový stav',
        priceUrl: 'Web cenníku',
        processed: 'Spracované',
        profile: 'Profil',
        range: 'Rozsah',
        reject: 'Zamietnuť',
        rejected: 'Zamietnutá',
        reload: 'Aktualizovať',
        remove: 'Odobrať',
        removeConfirmPoints: 'Odobrať body',
        save: 'Uložiť',
        shortDescription: 'Krátky popis',
        signUpGuide: 'Manuál pre registráciu',
        slogan: 'Slogan',
        sortOrder: 'Poradie',
        time: 'Čas',
        title: 'Názov',
        toc: 'všeobecnými obchodnými podmienkami pre poskytovateľov služieb',
        visibility: 'Viditeľnosť',
        visible: 'Viditeľné',
        visibleShe: 'Viditeľná',
        yes: 'Áno'
      },
      customer: {
        list: 'Registrovaní zákazníci',
        detail: 'Detail zákazníka',
        note: 'Poznámka k zákazníkovi',
        noteEdit: 'Zmeniť poznámku',
        notLoaded: 'Nepodarilo sa načítať detail zákazníka'
      },
      employee: {
        accessDeleted: 'Prístup zamestnanca bol zrušený',
        accessNotDeleted: 'Prístup zamestnanca sa nepodarilo zrušiť',
        add: 'Pridať zamestnanca',
        createAccess: 'Povoliť prístup',
        created: 'Zamestnanec bol vytvorený',
        createdAccess: 'Prístup vytvorený',
        deleteAccess: 'Zrušiť prístup',
        deleteAccessConfirm: 'Naozaj chcete zrušiť prístup zamestnanca?',
        deletePlanRangeConfirm: 'Naozaj chcete zmazať rozsah rozvrhov?',
        deletePlanRangeNote:
          'V prípade, že rozvrh už má rezerváciu, nebude zmazaný!',
        detail: 'Detail zamestnanca',
        edit: 'Upraviť zamestnanca',
        edited: 'Zamestnanec bol upravený',
        list: 'Zamestnanci',
        name: 'Zamestnanec',
        nullSelect: 'Bez zamestnanca',
        notCreated: 'Nepodarilo sa vytvoriť zamestnanca',
        notCreatedAccess: 'Nepodarilo sa vytvoriť prístup',
        notEdited: 'Nepodarilo sa upraviť zamestnanca',
        notLoaded: 'Nepodarilo sa načítať zamestnanca',
        plan: 'Rozvrh',
        planCreated: 'Rozvrh bol vytvorený',
        planNotCreated: 'Rozvrh sa nepodarilo vytvoriť',
        planDelete: 'Vymazať rozvrh',
        planDeleted: 'Rozvrh bol zmazaný',
        planNotDeleted: 'Rozvrh sa nepodarilo zmazať',
        select: 'Vyberte zamestnanca',
        selectMore: 'Vyberte zamestnancov'
      },
      error: {
        branch: {
          place: {
            not_found: 'Miesto na pobočke sa nenašlo'
          },
          not_found: 'Pobočka sa nenašla'
        },
        company: {
          already_exists: 'Poskytovateľ so zadaným IČO už existuje.'
        },
        email: {
          invalid: 'Zadaný email nie je správny'
        },
        employee: {
          not_found: 'Zamestnanec sa nenašiel',
          plan: {
            already_exists: 'Rozvrh už existuje',
            not_found: 'Rozvrh pre pracovníka neexistuje'
          }
        },
        phone_number: {
          invalid: 'Zadané telefónne číslo nie je správne'
        },
        reservation: {
          conflict: {
            branchPlace: 'Miesto na pobočke už má v danom čase rezerváciu.',
            employee: 'Zamestnanec už má v danom čase rezerváciu.',
            employee_plan: 'Rezervácia je cez viac rozvrhov zamestnanca.',
            resource: 'Zdroj už má v danom čase rezerváciu.'
          },
          strategy: {
            not_found: 'Neznáma stratégia pre rezerváciu,',
            missing_branchPlace: 'Služba vyžaduje miesto na pobočke.',
            missing_employee: 'Služba vyžaduje zamestnanca.',
            missing_resource: 'Služba vyžaduje zdroj.'
          }
        },
        resource: {
          not_found: 'Zdroj sa nepodarilo nájsť'
        },
        unknown: {
          error: 'Neočakávaná chyba'
        }
      },
      form: {
        checkData: 'Skontrolujte vyplnené údaje',
        checkLoginData: 'Skontrolujte prihlasovacie údaje',
        constraint: {
          capacityBlank: 'Ponechajte prázdne, ak neobmedzené',
          forrange0min: '0 minút pre interval',
          gte2ch: 'aspoň 2 znaky',
          gte6ch: 'aspoň 6 znakov',
          min0min: 'minimálne 0 minút',
          min1min: 'minimálne 1 minúta',
          openHours: 'Ponechajte prázdne, ak nepretržitá prevádzka',
          openHoursFormat:
            'Príklad formátu pre vyplnenie: 09:00-19:00 alebo 08:00-11:00,12:00-18:00',
          phoneFormat: 'formát +421xxxyyyzzz',
          zipFormat: 'formát xxxxx (bez medzier)',
          passwordFormat: 'formát minimálne 8 znakov, malé, veľké písmená, čísla, špeciálne znaky',
          priceblank: 'Ponechajte prázdne, ak nechcete použiť cenu',
          timeFormat: 'Formát času hh:mm',
          timeRangeBlank: 'Ponechajte prázdne, ak sa nepoužíva'
        },
        field: {
          branchCancelLimit: 'Minimálny čas pre zrušenie rezervácie v minútach',
          branchServiceInterval: 'Interval medzi časovými oknami',
          duration: 'Čas trvania služby v minútach',
          iban: 'IBAN',
          internalName: 'Interný názov',
          time_after: 'Blokovaný čas po rezervácii v minútach',
          time_before: 'Blokovaný čas pred rezerváciou v minútach',
          time_range_start: 'Začiatočný čas pre rezervácie',
          time_range_end: 'Konečný čas pre rezervácie',
          timeFrom: 'Čas od',
          timeTo: 'Čas do'
        },
        optional: 'Nepovinné',
        required: 'Povinné',
        validation: {
          addressRequired: 'Adresa musí byť vyplnená',
          body: {
            required: 'Telo musí byť vyplnené.'
          },
          email: 'Email musí byť vo validnom formáte',
          emailRequired: 'Email je povinný',
          gte2ch: 'Musia byť vyplnené aspoň 2 znaky',
          gte6ch: 'Musí byť vyplnených aspoň 6 znakov',
          ibanValidator: 'IBAN musí byť vo validnom formáte',
          imageRequired: 'Obrázok je povinný',
          internalName: {
            required: 'Interný názov musí byť vyplnený.'
          },
          invalidForm: 'Informácie vo formulári nie sú správne.',
          name: {
            required: 'Názov musí byť vyplnený.'
          },
          name_sk: {
            required: 'Názov v slovenskom jazyku musí byť vyplnený.'
          },
          name_en: {
            required: 'Názov v anglickom jazyku musí byť vyplnený.'
          },
          name_cs: {
            required: 'Názov v českom jazyku musí byť vyplnený.'
          },
          name_de: {
            required: 'Názov v nemeckom jazyku musí byť vyplnený.'
          },
          name_pl: {
            required: 'Názov v poľskom jazyku musí byť vyplnený.'
          },
          password: 'Heslo musí mať správny tvar, musí mať minimálne 8 znakov, aspoň 1 malé písmeno, aspoň 1 veľké písmeno, aspoň 1 číslo, aspoň 1 špeciálny znak',
          perex_sk: {
            required: 'Popis v slovenskom jazyku musí byť vyplnený.'
          },
          perex_en: {
            required: 'Popis v anglickom jazyku musí byť vyplnený.'
          },
          perex_cs: {
            required: 'Popis v českom jazyku musí byť vyplnený.'
          },
          perex_de: {
            required: 'Popis v nemeckom jazyku musí byť vyplnený.'
          },
          perex_pl: {
            required: 'Popis v poľskom jazyku musí byť vyplnený.'
          },
          body_sk: {
            required: 'Telo novinky v slovenskom jazyku musí byť vyplnený.'
          },
          body_en: {
            required: 'Telo novinky v anglickom jazyku musí byť vyplnený.'
          },
          body_cs: {
            required: 'Telo novinky v českom jazyku musí byť vyplnený.'
          },
          body_de: {
            required: 'Telo novinky v nemeckom jazyku musí byť vyplnený.'
          },
          body_pl: {
            required: 'Telo novinky v poľskom jazyku musí byť vyplnený.'
          },
          perex: {
            required: 'Popis musí byť vyplnený.'
          },
          shortDescriptionSk: {
            required: 'Krátky popis v slovenskom jazyku musí byť vyplnený.'
          },
          shortDescriptionEn: {
            required: 'Krátky popis v anglickom jazyku musí byť vyplnený.'
          },
          shortDescriptionCs: {
            required: 'Krátky popis v českom jazyku musí byť vyplnený.'
          },
          shortDescriptionDe: {
            required: 'Krátky popis v nemeckom jazyku musí byť vyplnený.'
          },
          shortDescriptionPl: {
            required: 'Krátky popis v poľskom jazyku musí byť vyplnený.'
          },
          minutes0: 'Minimálna hodnota je 0',
          minutes1: 'Minimálna hodnota je 1',
          ohValidator:
            'Nesprávny formát (príklady: 09:00-19:00 alebo 08:00-11:00,12:00-18:00)',
          personName: {
            required: 'Meno musí byť vyplnené.'
          },
          personLastname: {
            required: 'Priezvisko musí byť vyplnené.'
          },
          phoneNumberRequired: 'Telefónne číslo musí byť vyplnené',
          phoneNumberValidator: 'Telefónne číslo musí byť vo validnom formáte',
          phoneOrEmail: 'Email alebo telefón musí byť vyplnený.',
          timeValidator: 'Čas musí byť vo validnom formáte hh:mm',
          points: 'Počet bodov musí byť kladné číslo',
          requiredField: 'Pole je povinné',
          url: 'Webová adresa musí byť vo validnom formáte',
          imageUrl: 'Neplatná adresa obrázku',
          zipValidator: 'PSČ musí byť vo validnom formáte',
          durationRequiredForStrategy: 'Čas trvania služby v minútach musí byť väčší ako 0'
        }
      },
      locale: {
        selectOne: 'Vybrať jazyk'
      },
      loyalty: {
        text: 'Vernostný program',
        updated: 'Texty uravené',
        notUpdated: 'Nepodarilo sa upraviť texty',
        notLoaded: 'Nepodarilo sa načítať texty'
      },
      news: {
        add: 'Pridať novinku',
        body: 'Telo novinky',
        create: 'Vytvoriť novinku',
        created: 'Novinka bola vytvorená',
        detail: 'Detail novinky',
        edit: 'Upraviť novinku',
        edited: 'Novinka bola upravená',
        imageSquare: 'Obrázok do zoznamu noviniek',
        imageWide: 'Obrázok do detailu novinky',
        list: 'Novinky',
        notCreated: 'Novinku sa nepodarilo vytvoriť',
        notEdited: 'Novinku sa nepodarilo upraviť',
        notLoaded: 'Novinku sa nepodarilo načítať'
      },
      points: {
        changed: 'Body boli zmenené',
        notChanged: 'Body sa nepodarilo zmeniť'
      },
      provider: {
        stats: {
          name: 'Štatistika',
          activeReservations: 'Nadchádzajúce rezervácie',
          activeBranches: 'Aktívne pobočky',
          activeServices: 'Aktívne služby',
          activeResources: 'Aktívne zdroje'
        }
      },
      public: {
        businessName: 'Obchodné meno',
        businessId: 'IČO',
        taxId: 'DIČ',
        vatRegistrationId: 'IČ DPH',
        forgotenPassword: 'Nastavenie / Zmena hesla',
        forgotenPasswordRequest: 'Zmeniť heslo',
        changePassword: 'Zmeniť heslo',
        login: 'Prihlásenie',
        loginFailed: 'Prihlásenie nebolo úspešné',
        loginIn: 'Prihlásiť sa',
        signUp: 'Registrácia',
        signUpFailed: 'Požiadavka o vytvorenie konta nebola poslaná',
        signUpRequest: 'Požiadať o vytvorenie konta',
        signUpSuccessfull: 'Požiadavka o vytvorenie konta bola poslaná'
      },
      posDevices: {
        list: 'Register POS zariadení'
      },
      profile: {
        edited: 'Profil upravený',
        notEdited: 'Nepodarilo sa upraviť profil',
        notLoaded: 'Nepodarilo sa načítať profil'
      },
      reservation: {
        add: 'Pridať rezerváciu',
        create: 'Vytvoriť rezerváciu',
        created: 'Rezervácia vytvorená',
        deleted: 'Rezervácia bola zrušená',
        list: 'Rezervácie',
        name: 'Rezervácia',
        notCreated: 'Rezerváciu sa nepodarilo vytvoriť',
        notDeleted: 'Rezerváciu sa nepodarilo zrušiť',
        reload: 'Aktualizovať rezervácie',
        state: {
          changed: 'Stav rezervácie zmenený',
          notChanged: 'Stave rezervácie sa nepodarilo zmeniť',
          title: 'Stav rezervácie',
          DONE_SUCCESS: 'Zákazník prišiel',
          DONE_CUSTOMER_DID_NOT_COME: 'Zákazník neprišiel'
        }
      },
      reservationStrategy: {
        name: 'Rezervačná stratégia',
        select: 'Vyberte rezervačnú stratégiu',
        service_employee: 'Služba - zamestnanec',
        service_resource_date: 'Služba - zdroj',
        service_resource_date_range: 'Služba - zdroj dátumový interval',
        service_branch_place_date: 'Služba - miesto',
        service_branch_place_date_range: 'Služba - miesto dátumový interval',
        description: {
          service_employee: 'Zamestnanec, ktorý vykonáva službu v rámci jedného dňa, a v rámci jeho rozvrhu (napr. strihanie, kozmetika, prednáška, konzultácia...)',
          service_resource_date: 'Zdroj, ktorý je využívaný v rámci jedného dňa (napr. požičiavanie športového náradia...)',
          service_resource_date_range: 'Zdroj, ktorý je využívaný počas viacero dní (napr. požičanie auta, viacdenný sprievodca...)',
          service_branch_place_date: 'Miesto, ktoré priamo prislúch k pobočke, využívané v rámci jedného dňa (napr. stôl v reštaurácii, športové ihrisko)',
          service_branch_place_date_range: 'Miesto, ktoré priamo prislúch k pobočke, využívané počas viacero dní (napr. ubytovanie)'
        }
      },
      resource: {
        add: 'Pridať zdroj',
        created: 'Zdroj bol vytvorený',
        detail: 'Detail zdroja',
        edit: 'Upraviť zdroj',
        edited: 'Zdroj bol upravený',
        list: 'Zdroje',
        name: 'Zdroj',
        nullSelect: 'Bez zdroja',
        notCreated: 'Nepodarilo sa vytvoriť zdroj',
        notEdited: 'Nepodarilo sa upraviť zdroj',
        notLoaded: 'Nepodarilo sa načítať zdroj',
        select: 'Vyberte zdroj',
        selectMore: 'Vyberte zdroje'
      },
      service: {
        add: 'Pridať službu',
        created: 'Služba bola vytvorená',
        detail: 'Detail služby',
        edit: 'Upraviť službu',
        edited: 'Služba bola upravená',
        list: 'Služby',
        name: 'Služba',
        notCreated: 'Nepodarilo sa vytvoriť službu',
        notEdited: 'Nepodarilo sa upraviť službu',
        notLoaded: 'Nepodarilo sa načítať službu',
        price: 'Cena služby',
        priceCurrency: 'Peňažná mena',
        priceOnWeb: 'Zobrazenie na webe',
        priceType: 'Typ ceny',
        priceTypeSelect: 'Vyberte typ ceny',
        priceUnit: 'Jednotka ceny',
        priceUnitSelect: 'Vyberte jednotku ceny',
        select: 'Vyberte službu',
        selectMore: 'Vyberte služby'
      },
      superadmin: {
        tools: {
          deleteUser: {
            delete: 'Zmazať',
            deleteConfirm: 'Potvrdiť zmazanie',
            failed: 'Používateľa sa nepodarilo zmazať',
            success: 'Používateľ bol zmazaný',
            title: 'Zmazať používateľa'
          },
          signUp: {
            approve: 'Schváliť žiadosť o registráciu',
            approved: 'Žiadosť o registráciu bola schválená',
            detail: 'Detail žiadosti o registráciu',
            edit: 'Upraviť žiadosť o registráciu',
            edited: 'Žiadosť o registráciu bola upravená',
            notApproved: 'Nepodarilo sa schváliť žiadosť o registráciu',
            notEdited: 'Nepodarilo sa upraviť žiadosť o registráciu',
            notLoaded: 'Nepodarilo sa načítať žiadosť o registráciu',
            notRejected: 'Nepodarilo sa zamietnuť žiadosť o registráciu',
            reject: 'Zamietnuť žiadosť o registráciu',
            rejected: 'Žiadosť o registráciu bola zamietnutá',
            title: 'Žiadosti o registráciu'
          }
        },
        toolsName: 'Nástroje pre správcu'
      },
      table: {
        search: {
          lastname: 'Vyhľadať priezvisko'
        }
      }
    }
  }
})
